import { useScorecardData } from 'hooks/scorecards';
import { getScorecardStates } from 'helpers';

export default function useScorecardStates() {
  const { status } = useScorecardData() || {};
  return getScorecardStates(status);
}
